import { render, staticRenderFns } from "./registrationlink.vue?vue&type=template&id=908ae1e4&scoped=true&"
import script from "./registrationlink.vue?vue&type=script&lang=js&"
export * from "./registrationlink.vue?vue&type=script&lang=js&"
import style0 from "./registrationlink.vue?vue&type=style&index=0&id=908ae1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908ae1e4",
  null
  
)

export default component.exports